<template>
	<div class="store-info-body">
		<div class="store-info-container">
			<div class="fx-title">
				<p>基础信息</p>
			</div>
			<el-form label-width="210px" :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" class="form-box">
				<el-form-item label="AppID：" prop="appid">
					<el-input v-model="ruleForm.appid" size='mini' class="short-input" placeholder="请输入AppID"></el-input>
				</el-form-item>
				<el-form-item label="密钥：">
					<el-input v-model="ruleForm.secret" size='mini' class="short-input" placeholder="请输入密钥" v-if="!secretFlag"></el-input>
					<el-input v-model="star" type="password" size='mini' class="short-input" disabled v-else></el-input>
					<el-button class="btn-reset" size='mini' type="primary" @click="reset">重置</el-button>
					<span style="color: red;margin-left: 20px;">密钥必须正确填写，买家小程序才会收到消息通知，密钥获取方式详见后台管理手册</span>
				</el-form-item>
				<el-form-item label="小程序名称：" prop="miniName">
					<el-input v-model="ruleForm.miniName" size='mini' class="short-input" placeholder="请输入小程序名称" maxlength="50" @input="checkSize"></el-input>
					<span style="color: red;margin-left: 20px;">请务必填写正确的小程序名称</span>
				</el-form-item>
				<el-form-item label="原始ID：">
					<el-input v-model="ruleForm.originAppid" size='mini' class="short-input" maxlength="40" placeholder="请输入原始ID"></el-input>
					<el-tooltip effect="dark" placement="right" popper-class="tip-class">
						<div slot="content">
							1、如开通了供应链8+极速订，并且需要在龙管家 APP中使用极速订时必须填写原始ID，否则无法使用;<br>
							2、不需要在龙管家 APP 中使用极速订无需填写<br>
							3、原始ID在腾讯公众平台-账号设置-账号信息下方：<a style="color:var(--fx-primary-color);text-decoration:underline;" href="https://mp.weixin.qq.com/" target="_blank">https://mp.weixin.qq.com/</a>
						</div>
						<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
					</el-tooltip>
				</el-form-item>
				<div class="fx-title">
					<p>订单通知模板</p>
				</div>
				<el-form-item label="订单状态变更通知是否启用：" prop="status2Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status2Id')" v-model="ruleForm.templateSetupList[1].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[1].showBtn" v-model="ruleForm.templateSetupList[1].templateId" :maxlength='100' @change="statusIdChange(1)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[1].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(1)">重置</el-button>
				</el-form-item>
				<el-form-item label="待付款提醒通知是否启用：" prop="status1Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status1Id')" v-model="ruleForm.templateSetupList[0].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[0].showBtn" v-model="ruleForm.templateSetupList[0].templateId" :maxlength='100' @change="statusIdChange(0)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[0].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(0)">重置</el-button>
				</el-form-item>
				<el-form-item label="订单发货通知是否启用：" prop="status3Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status3Id')" v-model="ruleForm.templateSetupList[2].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[2].showBtn" v-model="ruleForm.templateSetupList[2].templateId" :maxlength='100' @change="statusIdChange(2)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[2].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(2)">重置</el-button>
				</el-form-item>
				<el-form-item label="买家订单修改通知是否启用：" prop="status6Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status6Id')" v-model="ruleForm.templateSetupList[5].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[5].showBtn" v-model="ruleForm.templateSetupList[5].templateId" :maxlength='100' @change="statusIdChange(5)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[5].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(5)">重置</el-button>
				</el-form-item>

				<div class="fx-title">
					<p>退单通知模板</p>
				</div>
				<el-form-item label="申请退款通知是否启用：" prop="status4Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status4Id')" v-model="ruleForm.templateSetupList[3].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[3].showBtn" v-model="ruleForm.templateSetupList[3].templateId" :maxlength='100' @change="statusIdChange(3)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[3].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(3)">重置</el-button>
				</el-form-item>
				<el-form-item label="订单退款通知是否启用：" prop="status5Id">
					<el-select class="mini-select" size='mini' @change="statusChange('status5Id')" v-model="ruleForm.templateSetupList[4].openFlag">
						<el-option label="否" :value="false"></el-option>
						<el-option label="是" :value="true"></el-option>
					</el-select>
					<el-input :disabled="ruleForm.templateSetupList[4].showBtn" v-model="ruleForm.templateSetupList[4].templateId" :maxlength='100' @change="statusIdChange(4)" size='mini' class="short-input" placeholder="请输入微信公众平台配置的模板ID"></el-input>
					<el-button v-if="ruleForm.templateSetupList[4].showBtn" class="btn-reset" size='mini' type="primary" @click="resetClick(4)">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="store-info-btn">
			<!-- <el-button class="btn" size='small' plain type="primary" @click="cancel">取消</el-button> -->
			<el-button class="btn" size='small' type="primary" @click="saveInfo">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'empower',
	components: {
	},
	data () {
		var status1Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[0].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[0].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		var status2Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[1].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[1].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		var status3Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[2].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[2].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		var status4Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[3].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[3].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		var status5Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[4].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[4].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		var status6Id = (rule, value, callback) => {
			if (!this.ruleForm.templateSetupList[5].openFlag) {
				callback()
			} else {
				if (this.ruleForm.templateSetupList[5].templateId === '') {
					return callback(new Error('请填写模板ID'))
				} else {
					callback()
				}
			}
		}
		return {
			star: '******',
			secretFlag: false,
			ruleForm: {
				appid: '',
				originAppid: '',
				secret: '',
				miniName: '',
				selltype: 0,
				templateSetupList: [
					{
						'eventId': '1',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					},
					{
						'eventId': '2',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					},
					{
						'eventId': '3',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					},
					{
						'eventId': '4',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					},
					{
						'eventId': '5',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					},
					{
						'eventId': '6',
						'openFlag': false,
						'templateId': '',
						'showBtn': false
					}
				]
			},
			rules: {
				appid: [
					{ required: true, message: '请输入AppID', trigger: 'blur' }
				],
				miniName: [
					{ required: true, message: ' ', trigger: 'blur' }
				],
				status1Id: [
					{ required: true, validator: status1Id, trigger: 'blur' }
				],
				status2Id: [
					{ required: true, validator: status2Id, trigger: 'blur' }
				],
				status3Id: [
					{ required: true, validator: status3Id, trigger: 'blur' }
				],
				status4Id: [
					{ required: true, validator: status4Id, trigger: 'blur' }
				],
				status5Id: [
					{ required: true, validator: status5Id, trigger: 'blur' }
				],
				status6Id: [
					{ required: true, validator: status6Id, trigger: 'blur' }
				]
			}
		}
	},
	created () {
	},
	mounted () {
		this.shopid = sessionStorage.getItem('storeid')
		this.load()
	},
	methods: {
		resetClick (data) {
			this.ruleForm.templateSetupList[data].showBtn = false
		},
		statusIdChange (data) {
			this.ruleForm.templateSetupList[data].templateId = this.ruleForm.templateSetupList[data].templateId.trim()
			this.ruleForm.templateSetupList[data].templateId = this.ruleForm.templateSetupList[data].templateId.replace(/[',\\]/g, '')
			this.ruleForm.templateSetupList[data].templateId = this.ruleForm.templateSetupList[data].templateId.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, '')
		},
		statusChange (data) {
			this.$refs.ruleForm.validateField(data, (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
		},
		load () {
			let data = {
				shopid: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/wechatinfo/get`,
				data: data
			}).then(res => {
				if (res.result) {
					this.ruleForm.appid = res.data.appid
					this.secretFlag = res.data.existSecretFlag
					this.ruleForm.selltype = res.data.selltype
					this.ruleForm.miniName = res.data.appname
					this.ruleForm.originAppid = res.data.originAppid
					if (res.data.templateSetupList) {
						let list = [
							{
								'eventId': '1',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							},
							{
								'eventId': '2',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							},
							{
								'eventId': '3',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							},
							{
								'eventId': '4',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							},
							{
								'eventId': '5',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							},
							{
								'eventId': '6',
								'openFlag': false,
								'templateId': '',
								'showBtn': false
							}
						]
						res.data.templateSetupList.forEach(item => {
							let num = +item.eventId - 1
							list[num].openFlag = item.openFlag
							list[num].templateId = item.templateId
							list[num].showBtn = item.templateId !== ''
						})
						this.ruleForm.templateSetupList = list
						console.log(this.ruleForm.templateSetupList[5])
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		reset () {
			this.ruleForm.secret = ''
			this.secretFlag = false
		},
		checkTemplate () {
			let list = this.ruleForm.templateSetupList
			let num = 0
			let arr = ['1', '2', '3', '6']
			list.forEach(item => {
				if (arr.includes(item.eventId) && item.openFlag) {
					num++
				}
			})
			if (num > 3) {
				this.$message.error('订单通知模板最多同时启用3个！')
				return false
			} else {
				return true
			}
		},
		saveInfo () {
			let that = this
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					that.$confirm(`AppID直接影响用户登录使用，请确认填写是否正确！`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false
					}).then(() => {
						if (!this.checkTemplate()) {
							this.load()
							return false
						}
						let data = {
							shopid: this.shopid,
							wechatAppid: that.ruleForm.appid,
							wechatAppname: that.ruleForm.miniName,
							selltype: that.ruleForm.selltype,
							templateSetupList: this.ruleForm.templateSetupList,
							originAppid: this.ruleForm.originAppid
						}
						if (!that.secretFlag) {
							data.wechatSecret = that.ruleForm.secret
						}
						that.$store.dispatch('requestPost', {
							url: `${that.$fxBaseApi.urlQIVShop}/wechatinfo/save`,
							data: data
						}).then(res => {
							if (res.result) {
								that.load()
								that.$message.success(res.msg)
							} else {
								that.$message.error(res.msg)
							}
						})
					}).catch(() => {
					})
				} else {
					return false
				}
			})
		},
		checkSize () {
			if (this.ruleForm.miniName.length > 50) {
				this.$message.error('请输入50个字以内的小程序名称！')
				return false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-info-body {
	overflow :hidden;
	display flex;
	height: 100%;
	min-height: 0;
	flex: 1;
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.mini-select{
		width :80px;
		margin-right :20px
	}
	.store-info-container {
		display flex;
		flex: 1;
		overflow-y: auto;
		flex-direction column;
		.form-box {
			display flex
			flex-direction column
			text-align left
			.short-input {
				width: 250px
			}
			.btn-reset {
				margin-left: 20px;
				width: 80px;
			}
			.tip-icon {
				display: inline-block;
				margin-left: 20px;
				cursor: pointer;
			}
		}
	}
	.store-info-btn {
		box-sizing: border-box;
		height:80px;
		text-align left
		padding: 20px 0
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}
</style>
